// This file is auto-generated by @skynet/data-helpers/scripts/generate-rtk-exports.mjs
// Do not edit manually.

import { hookExports } from './dex-token-map-api';

export const useGetTokenMap: typeof hookExports.useGetTokenMap = hookExports.useGetTokenMap;
export const useLazyGetTokenMap: typeof hookExports.useLazyGetTokenMap =
  hookExports.useLazyGetTokenMap;
export const useBindTokenMap: typeof hookExports.useBindTokenMap = hookExports.useBindTokenMap;
export const useUnbindTokenMap: typeof hookExports.useUnbindTokenMap =
  hookExports.useUnbindTokenMap;
